module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.appClass,
    attrs: {
      "id": "app"
    }
  }, [(_vm.auth.recovering) ? _c('div', {
    staticClass: "jumbotron bg-transparent text-center margin-none"
  }, [_c('h2', [_vm._v("管理机连接中断，正在等待恢复...")]), _vm._v(" "), _c('p', [_vm._v("服务恢复后会自动重新检查登录状态。")])]) : (!_vm.auth.ready) ? _c('div', {
    staticClass: "jumbotron bg-transparent text-center margin-none"
  }, [_c('h2', [_vm._v("正在检查登录状态...")])]) : (!_vm.auth.authenticated) ? _c('login-page', {
    attrs: {
      "initialized": _vm.auth.initialized
    },
    on: {
      "authenticated": _vm.handleAuthenticated
    }
  }) : [_c('navbar', {
    attrs: {
      "store": _vm.store,
      "auth": _vm.auth
    },
    on: {
      "logout": _vm.logout
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "store": _vm.store
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "split-vertical"
  }, [_c('div', {
    staticClass: "split-vertical-body"
  }, [_c('div', {
    staticClass: "split-vertical-cell"
  }, [_c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1)])])])]), _vm._v(" "), _c('foot'), _vm._v(" "), _c('message', {
    attrs: {
      "store": _vm.store
    }
  }), _vm._v(" "), _c('permission', {
    attrs: {
      "store": _vm.store
    }
  }), _vm._v(" "), _c('restart', {
    attrs: {
      "store": _vm.store
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cad49406"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 93
// module chunks = 0